import * as React from 'react'
import { ValueContainerProps, components } from 'react-select'
import { TeamOption } from '../team-select.types'

export const ValueContainer = (props: ValueContainerProps<TeamOption>) => (
  <components.ValueContainer {...props} className="py-1 min-h-[40px] gap-y-2" />
)
